// @flow
import React, { useState, useContext, Fragment } from 'react';
import classnames from 'classnames';

import ResponsiveContext from 'Components/utils/responsive/responsiveContext';
import Image from 'Components/frameworks/image/Image';
import { TrackClick } from 'Tracking/track-click/TrackClick';
import DynamicLink from 'Components/frameworks/dynamic-link/DynamicLink';

type ThematicCardProps = {
  mediaUrl: string,
  link?: string,
  itemTitle: string,
  isExclusiveCollection: boolean,
  isFirst: boolean,
};

export const ThematicCard = ({
  isExclusiveCollection,
  mediaUrl,
  itemTitle,
  link,
  isFirst,
}: ThematicCardProps) => {
  const [isHover, setHover] = useState(false);
  const { isTablet } = useContext(ResponsiveContext);

  const blockDimensions = isTablet
    ? { height: '235px', width: '180px' }
    : { height: '313px', width: '240px' };

  const handleFocus = () => {
    setHover(true);
  };

  const handleBlur = () => {
    setHover(false);
  };

  const TagName = link ? TrackClick : Fragment;
  const thematicTitle = itemTitle ? itemTitle : '';
  const trackingData = {
    actionGA: 'push_content_thematic',
    labelGA: `${thematicTitle}`.trim(),
  };
  const conditionalTagNameProps = link
    ? { as: DynamicLink, url: link, trackingData, className: 'z-1' }
    : {};

  return (
    <div
      style={{
        ...blockDimensions,
        flexShrink: '0',
      }}
      onMouseEnter={handleFocus}
      onMouseLeave={handleBlur}
      onFocus={handleFocus}
      onBlur={handleBlur}
      data-testid="ThematicLine-item"
      className={classnames(
        'rounded-tiny overflow-hidden p-3 py-6 rtl:ml-5 text-center flex items-end justify-center relative',
        { 'inset-border-after font-serif': isExclusiveCollection },
        { 'lg:rtl:ml-0': isFirst },
      )}
    >
      <Image
        className={classnames('absolute inset-0 transition-transform', {
          'scale-105': isHover && link,
        })}
        altMsg=""
        imageUrl={mediaUrl}
        mandatoryWidthAndHeight={{ h: 313, w: 240 }}
      />
      <div
        style={{
          position: 'absolute',
          top: 0,
          right: 0,
          bottom: 0,
          left: 0,
          /* eslint-disable no-dupe-keys */
          background: '-moz-linear-gradient(top, rgba(0,0,0,0) 50%, rgba(0,0,0,0.4) 100%)',
          background: '-webkit-linear-gradient(top, rgba(0,0,0,0) 50%,rgba(0,0,0,0.4) 100%)',
          background: 'linear-gradient(to bottom, rgba(0,0,0,0) 50%,rgba(0,0,0,0.4) 100%)',
        }}
      />
      <TagName {...conditionalTagNameProps}>
        <div
          className={classnames('absolute inset-0', {
            'z-1': !!link,
          })}
        />
        <div className="relative text-white text-xl leading-tight font-bold">{itemTitle}</div>
      </TagName>
    </div>
  );
};
